/**
 * Artifacts Translations - English
 */

export default {
	title: 'Artifacts',
	addNew: 'Add artifact',
	empty: 'No artifacts yet',

	// Facet types
	highlights: {
		name: 'Highlights',
		description: 'Key takeaways from this topic',
	},
	deepDive: {
		name: 'Deep dive',
		description: 'Extended analysis and context',
	},
	summary: {
		name: 'Summary',
		description: 'Brief overview of the content',
	},
	quiz: {
		name: 'Quiz',
		description: 'Test your understanding',
		empty: 'No quiz available',
		comingSoon: 'Interactive quiz coming soon',
		explanation: 'Explanation',
	},
	notes: {
		name: 'Notes',
		description: 'Your personal notes',
		placeholder: 'Start typing your notes...',
		empty: 'No notes yet',
		startWriting: 'Start writing',
		lastUpdated: 'Last updated',
		saved: 'Notes saved successfully',
	},
	diagram: {
		name: 'Diagram',
		description: 'Visual representation',
		empty: 'No diagram available',
		create: 'Create diagram',
		loading: 'Loading diagram…',
		preparing: 'Preparing view…',
		emptyMessage: 'No diagram yet.',
		untitled: 'Untitled',
		nodeFallback: 'Node {{index}}',
		connectionType: {
			bezier: 'Bezier',
			smoothStep: 'Smooth',
		},
	},
	flashcards: {
		name: 'Flashcards',
		description: 'Study cards for memorization',
	},
	routeCards: {
		name: 'Cards',
		title: 'Cards',
		deckLabel: 'Card deck',
		backToRoute: 'Back to {{mainEntityLabelLower}}',
		factsLabel: 'Key facts for this {{mainEntityLabelLower}}',
		reveal: 'Reveal',
		showFront: 'Show concept',
		empty: 'No cards for this {{mainEntityLabelLower}} yet.',
		generateErrorToast: {
			title: "We couldn't generate the cards",
			description: 'Something went wrong. Please try again.',
		},
		modality: {
			review: 'Review',
			facts: 'Key facts',
		},
	},
	keyConcepts: {
		name: 'Key concepts',
		description: 'Important concepts to remember',
	},

	summarizePost: {
		name: 'Summary',
		description: 'Generate a concise summary',
	},
	highlightCriticalConcepts: {
		name: 'Critical concepts',
		description: 'Highlight and explain the most important concepts',
	},
	offerPracticalExamples: {
		name: 'Practical examples',
		description:
			'Offer practical, real-world examples to illustrate the content',
	},
	recommendApplicationExercises: {
		name: 'Application exercises',
		description: 'Recommend exercises to apply what you learned',
	},
	createActionPlan: {
		name: 'Action plan',
		description: 'Turn the content into a practical action plan',
	},

	// Content viewer
	content: {
		empty: 'No content available',
	},

	// Generic viewer
	generic: {
		type: 'Type',
		facet: 'Facet',
		metadata: 'Metadata',
		content: 'Content',
		noContent: 'No content available',
	},

	// Actions
	actions: {
		edit: 'Edit',
		delete: 'Delete',
		generate: 'Generate',
		save: 'Save',
		cancel: 'Cancel',
		highlightSelection: 'Highlight selection',
		generateHighlights: 'Generate highlights',
		generateQuiz: 'Generate quiz',
		addNotes: 'Add notes',
	},

	// Errors
	errors: {
		loadFailed: 'Failed to load artifacts',
		saveFailed: 'Failed to save artifact',
		deleteFailed: 'Failed to delete artifact',
		generateFailed: 'Failed to generate artifact',
	},

	// Types for Config Studio multiselect
	types: {
		summary: 'Summary',
		notes: 'Notes',
		flashcards: 'Flashcards',
		diagram: 'Diagram',
		keyConcepts: 'Key concepts',
	},

	// Dialog
	dialogTitle: 'Artifacts',
	dialogDescription: 'View and manage generated content for this topic',
	manage: 'Artifacts',
	manageTooltip: 'Create and manage artifacts',
	noContent: 'No content for this artifact type',
}
